import { AxiosError } from "axios";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { Intent, IntentCreate } from "@/model";
import intentRepository from "@/repository/intentRepository";
import { intentQueryKeys } from "./keys";


export const useCreateIntent = (agentId: number, skillId?: number) => {
    const queryClient = useQueryClient();

    return useMutation<Intent, AxiosError, IntentCreate>({
        mutationKey: ["intent", "create", agentId, skillId],
        mutationFn: async (body: IntentCreate) => {
            try {
                const { data } = await intentRepository.create(agentId, skillId!, body);
                return data.data;
            } catch (e) {
                throw e;
            }
        },
        onSuccess: async () => {
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.intents(agentId, skillId)
            });
            await queryClient.invalidateQueries({
                queryKey: intentQueryKeys.names(agentId),
                refetchType: "all"
            });
        }
    });
};
